import Axios from 'axios';
import Head from 'next/head';
import { useRouter } from 'next/router';
import React, { useCallback, useEffect, useState } from 'react';
import getMetaTagData from '../../../src/common/services/getMetaTagData';
import { getAppLinkInBox } from '../../../src/common/utils/appLinkUtil';
import {
  deduplArray,
  deduplChannelArray
} from '../../../src/common/utils/convertUtil';
import {
  getLiveChannelType,
  getLivePlanArray,
  toPlanUrl
} from '../../../src/common/utils/liveUtil';
import { isSbsApp } from '../../../src/common/utils/passUtil';
import AdGenerater from '../../../src/component/m/ads/AdGenerater';
import ChannelTab from '../../../src/component/m/live/ChannelTab';
import ChannelTab24tv from '../../../src/component/m/live/ChannelTab24tv';
import CurrentProgram from '../../../src/component/m/live/CurrentProgram';
import Player from '../../../src/component/m/live/PlayerBox';
import ProgramBox from '../../../src/component/m/live/ProgramBox';
import QuickButtons from '../../../src/component/m/live/QuickButtons';
import ScheduleBottom from '../../../src/component/m/live/ScheduleBottom';
import ScheduleList from '../../../src/component/m/live/ScheduleList';

const LiveViewPage = (props) => {
  const isApp = isSbsApp();
  const router = useRouter();
  const { channelID } = router.query || 'S01';
  const [shouldRender, setShouldRender] = useState(false);
  const [type, setType] = useState('tv');
  const [selectedChannel, setSelectedChannel] = useState(
    props.data?.onair?.info.channelid || 'S01'
  );
  const [data, setData] = useState(props.data);
  const [channels, setChannels] = useState(props.channels);
  const [chats, setChats] = useState(props.chats);
  const [liveAnd24tv, setLiveAnd24tv] = useState(props.liveAnd24tv || []);
  const [livePlan, setLivePlan] = useState(props.schedules);
  const [channelname, setChannelname] = useState(
    props.data?.onair?.info.channelname || 'SBS'
  );

  const [alarms, setAlarms] = useState(() => {
    // 로컬 스토리지에서 알림등록 상태 로드
    if (typeof window !== 'undefined') {
      let savedAlarms = localStorage.getItem('alarms');
      if (savedAlarms) {
        const parsedAlarms = JSON.parse(savedAlarms);
        const currentDate = new Date();
        const filteredAlarms = Object.entries(parsedAlarms).reduce(
          (acc, [key, value]) => {
            const [, dateString] = key.split('_');
            const alarmDate = new Date(dateString.split(' ')[0]);
            const timeDiff = currentDate.getTime() - alarmDate.getTime();
            const daysDiff = timeDiff / (1000 * 3600 * 24);

            if (daysDiff < 3) {
              acc[key] = value;
            }
            return acc;
          },
          {}
        );

        return filteredAlarms;
      }
      return {};
    }
    return {};
  });


  // useEffect(() => {
  //   const updatePlan = async () => {
  //     try {
  //       const newPlan = await getLivePlanArray(channelID);

  //       setLivePlan(newPlan);
  //     } catch (error) {
  //       console.error('Failed to update live plan:', error);
  //     }
  //   };
  //   //? 24tv 채널은 5분마다 스케줄 업데이트
  //   const intervalId = setInterval(updatePlan, 5 * 60 * 1000);
  //   return () => clearInterval(intervalId);
  // }, [channelID]);

  useEffect(() => {
    if (!router.isReady) return;

    if (isApp && channelID) {
      router.replace(`/m/live/applegacy/${channelID}`);
    } else {
      setShouldRender(true);
    }
  }, [isApp, channelID, router]);

  useEffect(() => {
    if (!channelID) {
      router.replace('/m/live/S01', undefined, { shallow: true });
    }
  }, [channelID, router]);

  useEffect(() => {
    localStorage.setItem('alarms', JSON.stringify(alarms));
    window.toggleOnairAlarmActive = (isActive, channelId, date) => {
      // 앱에서 전달받은 channelId와 date URL 디코딩 처리
      channelId = decodeURIComponent(channelId);
      date = decodeURIComponent(date);

      const key = `${channelId}_${date}`;
      const newStates = { ...alarms };

      if (isActive) {
        newStates[key] = true;
      } else {
        delete newStates[key];
      }

      setAlarms(newStates);
      // 상태 변경 시 로컬 스토리지에도 즉시 저장
      localStorage.setItem('alarms', JSON.stringify(newStates));
      return newStates;
    };

    return () => {
      delete window.toggleOnairAlarmActive; // 언마운트시 제거
    };
  }, [alarms]);

  useEffect(() => {

    const fetchLiveData = async () => {
      try {
        const result = await liveAnd24tvData(type);
        setLiveAnd24tv(result || []);

        if (channelID !== 'S29') {
          const defaultChannel = type === '24tv' ? 'S21' : 'S01';

          const newPlan = await getLivePlanArray(defaultChannel, true);
          type === 'tv' ? setChannelname('SBS') : setChannelname(result[0].channelname)
          setLivePlan(newPlan);
        }

      } catch (err) {
        console.error('라이브 데이터 불러오기 실패:', err);
      } finally {
      }
    };

    fetchLiveData();
  }, [type]);

  useEffect(() => {
    const url = new URL(window.location.href);
    const paramsType = url.searchParams.get('type');
    if (paramsType?.toLowerCase() === '24tv') setType('24TV');

    // 페이지 로드 후 상단으로 가기 버튼 숨김처리
    const topButton = document.querySelector('.footer_btn_gotop');
    if (topButton) {
      topButton.style.display = 'none';
    }
  }, []);

  useEffect(() => {
    if (data?.onair?.info.channelid) {
      const channelType = getLiveChannelType(data?.onair.info.channelid);
      if (data?.onair?.info.channelid === 'S29') {
        setType('tv')
      } else {
        setType(channelType);
      }

      if (!isSbsApp() && channelType === 'radio') {
        if (confirm(`'SBS 고릴라' 앱에서 공감로그와 함께 청취 하시겠습니까?`)) {
          if (/android/i.test(window.navigator.userAgent)) {
            window.location.href = `intent://main?type=link#Intent;scheme=gorealra;package=com.appgate.gorealra;S.market_referrer=sharepage;end`;
          } else {
            window.location.href = `gorealra://`;
          }
        }
      }

      if (process.env.NODE_ENV === 'production') {
        setGoogleAnalytics(data?.onair?.info.channelid);
      }
    }
  }, [data?.onair]);

  const handleClickPlan = useCallback(
    (event) => {
      event.preventDefault();
      const url = toPlanUrl(data?.onair?.info.channelid);
      window.open(url, '_blank');
    },
    [data?.onair?.info.channelid]
  );

  const handleChannelChange = useCallback(

    async (channelId) => {
      try {

        const channelType = getLiveChannelType(channelId);

        const [newData, newChannels, newPlan, newChatData] = await Promise.all([
          onairData(channelId, channelType),
          channelData(channelId),
          getLivePlanArray(channelId, true),
          fetchChatData(channelId),
        ]);

        setData(newData);
        setChannels(newChannels);
        setLivePlan(newPlan);
        setChats(newChatData);

        setChannelname(newData?.onair?.info.channelname);

        if (isSbsApp()) {
          const appLink = getAppLinkInBox(channelId);
          window.location.href = appLink;
        }
        router.push(`/m/live/${channelId}`, undefined, { shallow: true });
      } catch (error) {
        console.error('채널 데이터 로딩 중 오류 발생:', error);
      }
    },
    [router]
  );

  const formatDateTime = useCallback((dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }, []);

  const handleAlarmToggle = useCallback((isActive, channelId, date) => {
    setAlarms((prev) => ({
      ...prev,
      [`${channelId}_${date}`]: isActive,
    }));
  }, []);

  return (
    <div style={{ display: shouldRender ? 'block' : 'none' }}>
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=UA-146376328-1"
        type="text/javascript"
      />
      <script src={process.env.NEXT_PUBLIC_URL_LIVE_JS_PLAYER_NEW} />
      <Head>
        <link
          rel="stylesheet"
          href={`${process.env.NEXT_PUBLIC_GLOBAL_CSS_M_URL}?v=${process.env.NEXT_PUBLIC_BUILD_TIME}`}
        />
        <meta
          name="viewport"
          content="user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, width=device-width"
        />
        <script
          type="text/javascript"
          src={process.env.NEXT_PUBLIC_GNB_JS_URL}
        />
        <meta name="description" content={props.metaTagData.shareDescription} />
        <meta name="keywords" content={props.metaTagData.keywords} />
        <meta name="twitter:card" content="summary" />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="ko_KR" />
        <meta property="og:site_name" content="SBS" />
        <meta
          property="og:title"
          content={props.metaTagData.shareTitle || ''}
        />
        <meta
          property="og:description"
          content={props.metaTagData.shareDescription || ''}
        />
        <meta
          property="og:image"
          content={props.metaTagData.shareImageUrl || ''}
        />
        <meta property="og:url" content={props.metaTagData.currentUrl || ''} />
        <meta name="nate:site_name" content="SBS" />
        <meta name="nate:title" content={props.metaTagData.shareTitle || ''} />
        <meta
          name="nate:description"
          content={props.metaTagData.shareDescription || ''}
        />
        <meta
          name="nate:image"
          content={props.metaTagData.shareImageUrl || ''}
        />
        <meta name="nate:url" content={props.metaTagData.currentUrl || ''} />
        <title>{props.metaTagData.shareTitle}</title>
      </Head>

      <div role="main" id="container" className="contents">
        <div className="live_end_wrap">
          <h2 className="hide">라이브</h2>

          {/* 라이브미리보기 플레이어 영역 */}
          {<Player info={data?.onair?.info} />}

          {/* 바로가기 버튼 */}
          <QuickButtons
            key={data?.onair?.info?.smr_programid ||
              data?.onair?.info?.program?.programid}
            jwt={props.jwtToken}
            smr_programid={
              data?.onair?.info?.smr_programid ||
              data?.onair?.info?.program?.programid
            }
            cpid={data?.onair?.ad_30?.cmdata?.cpid || data?.onair?.log_15?.cpid}
            program_title={data?.onair?.info?.program?.programtitle}
            channelid={data?.onair?.info?.channelid}
            channelname={data?.onair?.info?.channelname}
            thumbnail={
              data?.onair?.info?.thumbimg ||
              `https://program-image.cloud.sbs.co.kr/${data?.onair?.source?.channel}.jpg`
            }
            home_url={data?.onair?.info?.homeurl || data?.onair?.info?.home_url}
            vod_url={data?.onair?.info?.vod_url}
            chats={chats}
            share_title={data?.onair?.info?.title}
          />
          {
            <div className="contents_middle_ad">
              <div className="  ">
                <iframe
                  title="배너광고"
                  src={
                    type === '24tv'
                      ? '/html/m/24live_mo_top_320_100.htm'
                      : '/html/m/live_mo_middle_320100.htm'
                  }
                  width="320"
                  height="100"
                  scrolling="no"
                  allowtransparency="true"
                  style={{ border: 0, margin: '0px' }}
                ></iframe>
              </div>
            </div>
          }
          <>
            {/* 타이틀 탭 */}
            <div className="schedule_title_con01">
              <div className="schedule_title_group">
                <a
                  className={`btnText01 ${type !== '24tv' ? 'active' : ''}`}
                  onClick={(e) => {
                    e.preventDefault();
                    setType('tv');
                  }}
                  onTouchEnd={(e) => {
                    e.preventDefault();
                    setType('tv');
                  }}
                  role="button"
                  tabIndex={0}
                >
                  <span>실시간 라이브</span>
                </a>
                <a
                  className={`btnText01 ${type === '24tv' ? 'active' : ''}`}
                  onClick={(e) => {
                    e.preventDefault();
                    setType('24tv');
                  }}
                  onTouchEnd={(e) => {
                    e.preventDefault();
                    setType('24tv');
                  }}
                  role="button"
                  tabIndex={0}
                >
                  <span>24시간 TV</span>
                </a>
              </div>
              {type !== '24tv' ? (
                <div className="schedule_title_group">
                  <a
                    // href={toPlanUrl(data?.onair?.info.channelid)}
                    className="btnText02"
                    onClick={handleClickPlan}
                    role="button"
                    tabIndex={0}
                  >
                    <span>편성표</span>
                  </a>
                </div>
              ) : (
                <div className="schedule_title_group"></div>
              )}
            </div>

            {/* ##진행중인 프로그램 리스트 */}
            <CurrentProgram
              type={type}
              data={livePlan}
              channelName={channelname}
              alarms={alarms}
              onAlarmToggle={handleAlarmToggle}
              jwtToken={props.jwtToken}
              channelId={data?.onair?.info.channelid}
              formatDateTime={formatDateTime}
            />
            {/* ##채널 리스트 리스트 */}
            <ProgramBox
              data={liveAnd24tv}
              onChannelMove={handleChannelChange}
            />
          </>
        </div>
      </div>
    </div>
  );
};

export async function getServerSideProps(ctx) {
  const channelID = ctx.params.channelID || 'S01';
  const channelId = channelID; // 기존의 중복 할당 제거

  const { cookies } = ctx.req;
  const { LOGIN_JWT } = cookies;

  // 가상 또는 라디오채널은 채널이름 명확하지 않아 채널아이디로 하는게 좋아보임
  const channelType = getLiveChannelType(channelId);

  const [data, channels, plan, chatData, emoticonData, liveAnd24tv] = await Promise.all([
    onairData(channelId, channelType),
    channelData(channelId),
    getLivePlanArray(channelId, true),
    fetchChatData(channelId),
    fetchEmoticonData(),
    liveAnd24tvData()
  ]);
  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const metaTagData = getMetaTagData(ctx.req.url, channelId);
  if (data?.onair?.info.title) {
    metaTagData.shareTitle += data.onair.info.title;
    metaTagData.keywords = metaTagData.keywords.replace(
      '무료 스트리밍',
      data.onair.info.title + ' 무료 스트리밍'
    );
    metaTagData.keywords = metaTagData.keywords.replace(
      '무료 정주행',
      data.onair.info.title + ' 무료 정주행'
    );
    metaTagData.shareDescription = metaTagData.shareDescription.replace(
      '무료 스트리밍',
      data.onair.info.title + ' 무료 스트리밍'
    );
  }

  let programLikeCnt;
  if (data && data.onair.info.programid) {
    try {
      const likeCnt = await Axios.get(
        process.env.NEXT_PUBLIC_API_LIVE_PROGRAM_LIKE_COUNT +
        '/' +
        data.onair.info.smr_programid,
        { timeout: 3000 }
      );
      programLikeCnt = likeCnt.data?.count;
    } catch (e) {
      console.error(e);
    }
  }

  const apis = {
    info: process.env.NEXT_PUBLIC_API_LIVE_INFO,
    chatting_channel: process.env.NEXT_PUBLIC_API_LIVE_CHATTING_CHANNELS,
    chatting_user: process.env.NEXT_PUBLIC_API_LIVE_CHATTING_USER,
    chatting_report: process.env.NEXT_PUBLIC_API_LIVE_CHATTING_REPORT,
    translate: process.env.NEXT_PUBLIC_URL_LIVE_TRANSLATE_SOCKET,
    like: process.env.NEXT_PUBLIC_API_LIVE_PROGRAM_LIKE_SEND_V2,
  };

  return {
    props: {
      data: data || null,
      schedules: plan || null,
      channels: channels || null,
      like_cnt: programLikeCnt || null,
      info: data?.onair?.info || null,
      chats: chatData || null,
      emoticons: emoticonData || null,
      liveAnd24tv: liveAnd24tv || null,
      apis: apis || null,
      jwtToken: LOGIN_JWT || null,
      metaTagData,
    },
  };
}

const onairData = async (channelID, channelType) => {
  try {
    const apiChannelPath =
      channelType !== '24tv' ? 'channel' : 'binge-watch/channel';
    const infoApiUrl = `${process.env.NEXT_PUBLIC_API_LIVE_INFO}/${apiChannelPath}/${channelID}?v_type=2&platform=pcweb&protocol=hls&ssl=N&rscuse=&jwt-token=&sbsmain=`;

    const res = await Axios.get(infoApiUrl, { timeout: 3000 });
    const data = res.data;

    return data;
  } catch (e) {
    console.error('onairData 에러:', e);
    throw e;
  }
};

const liveAnd24tvData = async (channelType) => {
  try {
    if (channelType === '24tv') {
      const res = await Axios.get(
        `${process.env.NEXT_PUBLIC_API_LIVE_CHANNELS_24TV}?v_type=2`, { timeout: 3000 }
      );
      const data = res.data;
      if (!data || !data.list) return null;

      return data.list.filter((item) => item.channelname && item.channelid);
    } else {
      const res = await Axios.get(process.env.NEXT_PUBLIC_API_LIVE_CHANNELS, { timeout: 3000 });
      const data = res.data;
      if (!data || !data.list) return null;

      const tvList = data.list.filter((item) => item.type === 'TV');
      // const dedupedTV = deduplChannelArray(tvList, 'channelname', 'channelid');
      const dedupedTV = tvList;

      const radioList = data.list.filter(
        (item) => item.type === 'Radio' && item.onair_yn === 'Y'
      );
      const dedupedRadio = deduplArray(radioList, 'channelname', 'channelid');

      return [...dedupedTV, ...dedupedRadio];
    }
  } catch (e) {
    console.error('onairData 에러:', e);
    throw e;
  }
};




const channelData = async (channelID) => {
  try {
    const tvChannelList = await Axios.get(
      process.env.NEXT_PUBLIC_API_LIVE_CHANNELS,
      { timeout: 3000 }
    );
    // * 멀티오디오 추가로 중복채널 제거 로직 검토 필요
    //let channelTVData = tvChannelList.data.list.filter((item) => (item.type === 'TV' && item.channelid !== channelID));
    let channelTVData = tvChannelList.data.list.filter(
      (item) => item.type === 'TV'
    );
    channelTVData = channelTVData.map((x) => ({
      title: x.title || '정보없음',
      channelid: x.channelid, // 저지연, 멀티오디오 라벨 표시를 위해 추가
      desc: x.channelname,
      link: `/live/${x.channelid}`,
      pgm_title: x.title || '정보없음',
      img:
        x.channelid !== 'EVENT4'
          ? x.thumbs?.['640'] || x.thumbimg || x.program_image
          : x.thumbimg,
      starttime: x.starttime || null,
      endtime: x.endtime || null,
    }));

    const radioChannelList = await Axios.get(
      process.env.NEXT_PUBLIC_API_LIVE_CHANNELS,
      { timeout: 3000 }
    );
    const dupRadioArray = radioChannelList.data.list.filter(
      (item) => item.type === 'Radio' && item.onair_yn === 'Y'
    );
    let channelRadioData = deduplArray(
      dupRadioArray,
      'channelname',
      'channelid'
    );
    channelRadioData = channelRadioData.map((x) => ({
      title: x.title,
      channelid: x.channelid,
      desc: x.channelid === 'S19' ? '고릴라M' : x.channelname,
      link: `/live/${x.channelid}`,
      pgm_title: x.title,
      img: x.thumbs?.['640'] || x.thumbimg || x.program_image,
      starttime: x.starttime || null,
      endtime: x.endtime || null,
    }));

    const virtualChannelList = await Axios.get(
      `${process.env.NEXT_PUBLIC_API_LIVE_CHANNELS_24TV}?v_type=2`,
      { timeout: 3000 }
    );
    let channel24Data = virtualChannelList.data.list;
    channel24Data = channel24Data.map((x) => ({
      title: x.title || '정보없음',
      channelid: x.channelid, // 저지연, 멀티오디오 라벨 표시를 위해 추가
      desc: x.channelname,
      link: `/live/${x.channelid}`,
      pgm_tms_title: x.title || '정보없음',
      img: x.thumbs?.['640'] || x.thumbimg || x.program_image,
      starttime: x.starttime || null,
      endtime: x.endtime || null,
    }));

    return {
      tv: channelTVData,
      radio: channelRadioData,
      virtual: channel24Data,
    };
  } catch (e) {
    console.error('error:', e);
    return { tv: [], radio: [], virtual: [] };
  }
};

const fetchChatData = async (channelID) => {
  try {
    const response = await Axios({
      method: 'get',
      url: `${process.env.NEXT_PUBLIC_API_LIVE_CHATTING_CHANNELS}/${channelID}`,
      headers: {
        'Content-Type': 'application/json',
        Host: '',
      },
      timeout: 3000,
    });

    if (response.data) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    //console.error('채팅:', error);
    return null;
  }
};

const fetchEmoticonData = async () => {
  try {
    const response = await Axios.get(
      process.env.NEXT_PUBLIC_API_LIVE_CHATTING_EMOTICONS,
      {
        timeout: 3000,
      }
    );

    return response.data;
  } catch (error) {
    console.error('이모티콘:', error);
    return null;
  }
};

const setGoogleAnalytics = (channelID) => {
  let tagId, ga4TagId;
  switch (channelID) {
    case 'S02': // sbs sports
      tagId = 'UA-146376328-1';
      ga4TagId = 'G-8G453WZ76V';
      break;
    case 'S03': // sbs plus
      tagId = 'UA-146760740-2';
      ga4TagId = 'G-97W8RH442C';
      break;
    case 'S04': // sbs fune
      tagId = 'UA-146760740-3';
      ga4TagId = 'G-WQWE5WDT9F';
      break;
    // case 'S05': // sbs golf
    //   tagId = 'UA-100348188-1';
    //   break;
    case 'S06': // sbs biz
      tagId = 'UA-135761934-1';
      break;
    case 'S09': // sbs m
      tagId = 'UA-146888827-4';
      ga4TagId = 'G-0DM6QEB0KJ';
      break;
    case 'S10': // kizmom, S20 kpop,
      tagId = 'UA-146888827-5';
      ga4TagId = 'G-YHQ768DD4V';
      break;
    case 'S11': // fil
      ga4TagId = 'G-VL8DPHLZZJ';
      break;
    default:
      tagId = null;
      ga4TagId = null;
      break;
  }

  if (ga4TagId || tagId) {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', ga4TagId ? ga4TagId : tagId, {
      page_location: window.location.href,
      page_path: window.location.pathname,
      page_title: window.document.title,
    });
  }
};

export default LiveViewPage;
